import t from '@jetshop/intl';
import * as React from 'react';
import { SelectableListItem, SelectItem as OriginalSelectItem } from '../Components';
import styled from 'react-emotion';
const SelectItem = styled(OriginalSelectItem) `
  font-size: 80%;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;
class ClearFilter extends React.Component {
    render() {
        return (React.createElement(SelectableListItem, Object.assign({ type: "button", key: "clearItems" }, this.props.getItemProps({ item: {}, index: 0 })),
            React.createElement(SelectItem, null, t('Clear filter'))));
    }
}
export { ClearFilter };
//# sourceMappingURL=ClearFilter.js.map